import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import moment from 'moment'
import { Table, Segment, Grid, Header } from 'semantic-ui-react'
import LocationReportActions from '../../reducers/locationReportReducer'
import DownloadButton from './components/DownloadSheetButton'
import DateRangeField from './components/DateRangeField'

class LocationReport extends React.PureComponent {
  state = {
    startFrom: Number(
      moment()
        .startOf('month')
        .format('x')
    ),
    endAt: Number(
      moment()
        .endOf('month')
        .format('x')
    ),
  }

  getOrderByDate = () => {
    const { getOrderLocationsReport } = this.props
    const { startFrom, endAt } = this.state

    getOrderLocationsReport(startFrom, endAt)
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state
    const ONE_MONTH_IN_MILLISECOND = 2764800000

    const errors = []
    if (startFrom > endAt) {
      errors.push({ type: 'Date Invalid', value: 'Date invalid, please check it again' })
    }

    if (endAt - startFrom > ONE_MONTH_IN_MILLISECOND) {
      errors.push({
        type: 'Date Exceed a Month',
        value: 'Date range exceed the month, please check it again',
      })
    }

    return errors
  }

  onSearch = () => {
    const errors = this.validateSearchByDate()
    if (errors.length < 1) {
      this.getOrderByDate()
    } else {
      alert(errors.map(err => err.value).join(', '))
    }
  }

  generateDayGap = () => {
    const { startFrom, endAt } = this.state
    const momentStart = moment(startFrom)
    const momentEnd = moment(endAt)

    const weeksGap = parseInt((momentEnd.diff(momentStart, 'days') + 1) / 7, 10)

    const weeks = []
    for (let i = 0; i < weeksGap; i++) {
      const isLastColumn = i + 1 === weeksGap

      const startOfWeek = Number(moment(startFrom).add(i * 7, 'days'))
      const endOfWeek = Number(!isLastColumn ? moment(startOfWeek).add(6, 'days') : moment(endAt))

      const week = { from: startOfWeek, to: endOfWeek, index: i }

      if (!!week) weeks.push(week)
    }

    return weeks || []
  }

  renderingData = (weeks = undefined) => {
    const { data } = this.props
    if (weeks.length <= 0 || data.length <= 0) return {}
    let accum = { customers: {}, merchants: {}, famousMerchants: {}, allDistricts: new Set() }
    _.each(data, order => {
      const { created_at, merchant_name, customerDistrict, merchantDistrict } = order
      accum['allDistricts'].add(merchantDistrict)
      accum['famousMerchants'][merchant_name] = accum['famousMerchants'][merchant_name] || {}
      accum['famousMerchants'][merchant_name][customerDistrict] =
        accum['famousMerchants'][merchant_name][customerDistrict] === undefined
          ? 0
          : accum['famousMerchants'][merchant_name][customerDistrict] + 1

      _.each(weeks, week => {
        accum['customers'][customerDistrict] = accum['customers'][customerDistrict] || {}
        accum['merchants'][merchantDistrict] = accum['merchants'][merchantDistrict] || {}

        const isWithinDate = created_at >= week.from && created_at <= week.to
        if (!isWithinDate) return
        const weekFormat = `${week.from}-${week.to}`

        if (customerDistrict) {
          accum['customers'][customerDistrict][weekFormat] =
            accum['customers'][customerDistrict][weekFormat] === undefined
              ? 0
              : accum['customers'][customerDistrict][weekFormat] + 1
        }
        if (customerDistrict) {
          accum['merchants'][merchantDistrict][weekFormat] =
            accum['merchants'][merchantDistrict][weekFormat] === undefined
              ? 0
              : accum['merchants'][merchantDistrict][weekFormat] + 1
        }
      })
    })

    return accum
  }

  renderCustomerLocationStatistic = (weeks, data, allDistricts) => {
    return [...allDistricts].sort().map(disName => {
      const districts = data[disName] || []
      console.log(data, districts)
      return (
        <Table.Row key={`customer-${disName}`}>
          <Table.Cell> {disName} </Table.Cell>
          {_.map(weeks, week => {
            const timestamp = week.from + '-' + week.to
            return (
              <Table.Cell key={timestamp} textAlign="center">
                {districts[timestamp] || 0}
              </Table.Cell>
            )
          })}
          <Table.Cell textAlign="center"> {_.sum(Object.values(districts))} </Table.Cell>
        </Table.Row>
      )
    })
  }

  renderMerchantLocationStatistic = (weeks, data, allDistricts) => {
    return [...allDistricts].sort().map(disName => {
      const districts = data[disName] || []
      console.log(data, districts)
      return (
        <Table.Row key={`merchant-${disName}`}>
          <Table.Cell> {disName} </Table.Cell>
          {_.map(weeks, week => {
            const timestamp = week.from + '-' + week.to
            return (
              <Table.Cell key={timestamp} textAlign="center">
                {districts[timestamp] || 0}
              </Table.Cell>
            )
          })}
          <Table.Cell textAlign="center"> {_.sum(Object.values(districts))} </Table.Cell>
        </Table.Row>
      )
    })
  }

  render() {
    const { startFrom, endAt } = this.state
    const { loading } = this.props
    const weeks = this.generateDayGap()
    const { customers, merchants, famousMerchants, allDistricts = [] } = this.renderingData(weeks)

    return (
      <Segment style={{ height: '100%', overflow: 'auto' }}>
        <div style={{ padding: '0px 14px' }}>
          <DateRangeField
            loading={loading}
            startFrom={startFrom}
            endAt={endAt}
            onSearch={this.onSearch}
            onFieldChange={this.onFieldChange}
          />

          <Segment>
            <Grid columns="equal" style={{ marginTop: 10 }}>
              <Grid.Column>
                <Header size="large">Customer</Header>
                <Segment style={{ maxHeight: 700, overflow: 'auto' }}>
                  <Table basic="very">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell textAlign="left">Distict Name</Table.HeaderCell>
                        {weeks &&
                          weeks.map(header => {
                            return (
                              <Table.HeaderCell
                                textAlign="center"
                                key={`header-${header.from}-${header.to}`}
                              >{`${moment(header.from).format('DD')} - ${moment(header.to).format(
                                'DD-MMM'
                              )}`}</Table.HeaderCell>
                            )
                          })}
                        <Table.HeaderCell textAlign="center">Total</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {!loading && this.renderCustomerLocationStatistic(weeks, customers, allDistricts)}
                    </Table.Body>
                  </Table>
                </Segment>
              </Grid.Column>
              <Grid.Column>
                <Header size="large">Merchant</Header>
                <Segment style={{ maxHeight: 700, overflow: 'auto' }}>
                  <Table basic="very">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell textAlign="left">District Name</Table.HeaderCell>
                        {weeks &&
                          weeks.map(header => {
                            return (
                              <Table.HeaderCell
                                textAlign="center"
                                key={`header-${header.from}-${header.to}`}
                              >{`${moment(header.from).format('DD')} - ${moment(header.to).format(
                                'DD-MMM'
                              )}`}</Table.HeaderCell>
                            )
                          })}
                        <Table.HeaderCell textAlign="center">Total</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {!loading && this.renderMerchantLocationStatistic(weeks, merchants, allDistricts)}
                    </Table.Body>
                  </Table>
                </Segment>
              </Grid.Column>
            </Grid>
            <Grid columns="equal" style={{ marginTop: 10 }}>
              <Grid.Column>
                <Segment style={{ overflow: 'auto' }}>
                  <Header size="large">Famous Merchant</Header>
                  <div
                    style={{
                      height: 500,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {!loading && (
                      <DownloadButton
                        loading={loading}
                        orders={_.map(famousMerchants, (districts, merchantName) => {
                          return [
                            merchantName,
                            ...[...allDistricts].sort().map(districtName => districts[districtName] || 0),
                            _.sum(Object.values(districts)),
                          ].join(',')
                        })}
                        headers={[
                          'Name',
                          ...[...allDistricts].sort().map(districtName => districtName),
                          'Total',
                        ]}
                        filename={`famous-merchant-${startFrom}-${endAt}`}
                      />
                    )}
                  </div>
                </Segment>
              </Grid.Column>
            </Grid>
          </Segment>
        </div>
      </Segment>
    )
  }
}

const mapState = ({ orderLocations }) => ({
  data: orderLocations.data,
  loading: orderLocations.loading,
  loaded: orderLocations.loaded,
})

const mapDispatch = {
  getOrderLocationsReport: LocationReportActions.getOrderLocations,
}

export default connect(
  mapState,
  mapDispatch
)(LocationReport)



// WEBPACK FOOTER //
// ./src/containers/reports/location.js